<!--文件上传-->
<template>
  <div id="ListUploader" ref="ListUploader" class="uploader">
     <input
        v-if="isUploadDirectory"
        type="file"
        id="folderUploadInput"
        style="display: none;"
        webkitdirectory
        @change="directoryChange"
    />
    <div v-if="operate === 'renewal'">
      <el-upload
          v-if="renewalObj.fileType !== '数维道路'"
          ref="renewalUpload"
          class="drag-uploader"
          action="#"
          :multiple="false"
          :http-request="preUpload"
          :on-change="fileChange"
          :file-list="selectFile"
          :accept="allowTypes"
          :show-file-list="false"
          :auto-upload="false"
      />
    </div>
    <el-dialog
      v-else
      :visible.sync="modalVisible"
      :close-on-click-modal="false"
      width="960px"
      custom-class="uploader-dialog file-uploader-dialog"
      append-to-body
      @open="dialogOpen"
      @close="handleCancel"
    >
      <div slot="title">
        <el-tabs v-model="activeUploadTab" :before-leave="beforeUploadTabChange">
          <el-tab-pane label="上传文件" name="uploadFile"></el-tab-pane>
          <el-tab-pane label="上传数维道路工程" name="uploadGroad"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="files-container">
        <!--上传文件-->
        <el-upload
          v-if="activeUploadTab === 'uploadFile'"
          ref="upload"
          class="drag-uploader"
          action="#"
          drag
          multiple
          :http-request="preUpload"
          :on-change="fileChange"
          :file-list="selectFile"
          :accept="allowTypes"
          :show-file-list="false"
          :auto-upload="false"
          :limit="100"
          :on-exceed="onExceed"
        >
          <i class="el-icon-upload" />
          <div v-if="envPlatform === 'web'" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div v-else class="el-upload__text">点击上传文件</div>
          <div slot="tip" class="el-upload__tip">
            <span>当前支持上传的文件类型: {{ allowTypes }}文件</span>
            <span v-show="fileTable.length">{{ selectCount }} / {{ tableTotal }}</span>
          </div>
        </el-upload>
        <!--上传道路文件夹-->
        <div v-if="activeUploadTab === 'uploadGroad'" class="folder-upload">
          <div class="upload-click-area" :class="{'upload-disabled': fileTable.length}" @click.stop="clickUploadInput">
            <i class="el-icon-upload" />
            <div class="upload-text">点击上传文件夹</div>
          </div>
          <div class="upload-tip">
            <span style="margin-top: 3px;">当前支持上传的文件类型: 数维道路工程（文件夹）</span>
            <span v-show="fileTable.length">{{ selectCount }} / {{ tableTotal }}</span>
          </div>
        </div>
        <div v-if="fileTable.length">
          <el-table
            ref="multipleTable"
            :data="fileTable"
            style="width: 100%"
            max-height="300"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50" :selectable="canSelect" />
            <el-table-column prop="name" label="文件名" show-overflow-tooltip :formatter="fmtFileName" />
            <el-table-column prop="size" label="文件大小" width="84px" :formatter="fmtSize" />
          </el-table>
          <div class="uploader-tip mg-top-sm">注：<span class="strong">重名文件将自动更新版本</span>，文件上传过程中请勿刷新或切换页面，以免数据丢失</div>
        </div>
      </div>
      <template slot="footer">
        <div v-if="fileTable.length" class="footer">
          <div class="footer-oper">
            <el-button key="back" @click="handleCancel">取消</el-button>
            <el-button
              key="submit"
              type="primary"
              :disabled="!selectFile.length"
              :loading="loading"
              @click="handleOk"
            >{{ operate === 'renewal' ? '开始更新' : '开始上传' }}</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <!--上传列表-->
    <div class="upload-list" :class="{'list-fold':isFold}">
      <div class="upload-list-header">
        <span>任务列表（{{ overCount }}/{{ uploadTotal }}）</span>
        <span class="rotate-control" @click="isFold = !isFold">
          <i class="gjw-iconfont gjw-icon-fold rotate-icon" :class="{'icon-fold':isFold}" />
        </span>
      </div>
      <div v-show="!isFold" class="upload-list-content">
        <div v-show="!isFold" class="tabs">
          <div class="tab-item" :class="{'active': activeTab === 'upload'}" @click="showList('upload')">上传<span class="total">{{ uploadList.length }}</span></div>
          <div class="tab-item" :class="{'active': activeTab === 'renewal'}" @click="showList('renewal')">更新<span class="total">{{ renewalList.length }}</span></div>
        </div>
        <!--上传列表-->
        <div v-if="activeTab === 'upload'" key="upload" class="file-list">
          <ul v-if="uploadList.length">
            <li v-for="(file,index) in uploadList" :key="index" class="file">
              <span class="name ellipsis-text">{{ fmtFileName(file) }}</span>
              <span class="size ellipsis-text">{{ fmtSize(file) }}</span>
              <span class="progress">
                <el-progress :percentage="file.uploadProgress" :show-text="false" :color="customColor(file)" />
              </span>
              <span v-if="file.uploadStatus==='prepare'" class="status-span prepare"><i class="gjw-iconfont gjw-icon-icon_wait" />准备中...</span>
              <span v-if="file.uploadStatus==='waiting'" class="status-span waiting"><i class="gjw-iconfont gjw-icon-icon_wait" />等待上传</span>
              <span v-if="file.uploadStatus==='uploading'" class="status-span uploading"><i class="gjw-iconfont gjw-icon-icon_wait" />正在上传</span>
              <span v-if="file.uploadStatus==='success'" class="status-span success"><i class="gjw-iconfont gjw-icon-done" />上传成功</span>
              <span v-if="file.uploadStatus==='updateSuccess'" class="status-span success"><i class="gjw-iconfont gjw-icon-done" />更新成功</span>
              <span v-if="file.uploadStatus==='fail'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />上传失败</span>
              <span v-if="file.uploadStatus==='existed'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />资源已存在</span>
              <span v-if="file.uploadStatus==='fileExisted'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />文件已存在</span>
            </li>
          </ul>
          <div v-else class="empty-content">暂无数据</div>
        </div>
        <!--更新列表-->
        <div v-if="activeTab === 'renewal'" key="renewal" class="file-list">
          <ul v-if="renewalList.length">
            <li v-for="(file,index) in renewalList" :key="index" class="file">
              <span class="name ellipsis-text">{{ fmtFileName(file) }}</span>
              <span class="size ellipsis-text">{{ fmtSize(file) }}</span>
              <span class="progress">
                <el-progress :percentage="file.uploadProgress" :show-text="false" :color="customColor(file)" />
              </span>
              <span v-if="file.uploadStatus==='prepare'" class="status-span prepare"><i class="gjw-iconfont gjw-icon-icon_wait" />准备中...</span>
              <span v-if="file.uploadStatus==='waiting'" class="status-span waiting"><i class="gjw-iconfont gjw-icon-icon_wait" />等待更新</span>
              <span v-if="file.uploadStatus==='uploading'" class="status-span uploading"><i class="gjw-iconfont gjw-icon-icon_wait" />正在更新</span>
              <span v-if="file.uploadStatus==='success'" class="status-span success"><i class="gjw-iconfont gjw-icon-done" />更新成功</span>
              <span v-if="file.uploadStatus==='notExisted'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />资源不存在</span>
              <span v-if="file.uploadStatus==='fail'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />更新失败</span>
              <span v-if="file.uploadStatus==='md5Duplicate'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />文件重复</span>
              <span v-if="file.uploadStatus==='versionMismatch'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />版本不匹配</span>
            </li>
          </ul>
          <div v-else class="empty-content">暂无数据</div>
        </div>
        <div class="uploader-tip upload-content-tip">注：文件处理过程中请勿刷新或切换页面，以免数据丢失。</div>
      </div>
    </div>
  </div>
</template>

<script>
import { RegSymbol } from '@/core/RegExp'
import Tools from '@/core/tools'
import Utils from '@/core/utils'
import Upload from '@/core/upload'
import Queue from '@/core/queue'
import { mapGetters } from 'vuex'
export default {
  name: 'ListUpload',
  props: {
    platform: {
      type: String,
      default: null
    },
    renewalObj: {
      type: Object,
      default() {
        return {}
      }
    },
    allowTypes: { // 允许上传的文件格式
      type: String,
      default: '.gac'
    },
    softwareVersion: [String, Number],
    softwareCode: [String, Number],
    fileTableColumns: {
      type: Object,
      default() {
        return {}
      }
    },
    // 上传至 的 所有分类来源
    spaceClassifyTree: {
      type: Array,
      default() {
        return []
      }
    },
    // 用户选中的分类
    spaceCategoryId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      activeUploadTab: this.softwareCode === 'AppGroad' ? 'uploadGroad' : 'uploadFile',
      upQueue: new Queue(5, this.uploading, this.uploadWait),
      RegSymbol,
      modalVisible: false,
      loading: false,
      fileTable: [], // 所有等待上传的文件
      selectFile: [], // 已勾选的文件
      directoryFiles: null, // 道路文件夹中所有的文件, 是个对象
      directoryName: '', // 道路文件夹名
      isFold: true, // 是否收起状态
      // 上传文件列表
      uploadList: [],
      // 更新文件列表
      renewalList: [],
      activeTab: 'upload',
      operate: 'upload', // 操作类型：upload / renewal
      spaceId: this.$route.params.spaceId
    }
  },
  computed: {
    ...mapGetters({
      envPlatform: 'platform',
      softwareVersionNameMap: 'common/softwareVersionNameMap',
      canEmitWebEventToDesktop: 'canEmitWebEventToDesktop'
    }),
    isUploadDirectory() {
      return (this.modalVisible && this.activeUploadTab === 'uploadGroad') || (this.operate === 'renewal' && this.renewalObj.fileType === '数维道路')
    },
    uploadTableData() {
      return [...this.uploadList, ...this.renewalList]
    },
    tableTotal() {
      return this.fileTable.length
    },
    selectCount() {
      return this.selectFile.length
    },
    uploadTotal() {
      return this.uploadTableData.length || 0
    },
    overCount() {
      const arr = this.uploadTableData.filter((file) => {
        return !['uploading', 'waiting', 'prepare'].includes(file.uploadStatus) && file.status !== 'processing'
      })
      return arr.length || 0
    },
  },
  methods: {
    showModal(operate) {
      this.operate = operate
      this.modalVisible = true
      // 修复el-tabs初始选中样式问题
      this.$nextTick(() => {
        const activeBarElement = document.getElementsByClassName('el-tabs__active-bar')[0]
        activeBarElement.style.width = this.activeUploadTab === 'uploadFile' ? '56px' : '112px'
        activeBarElement.style.transform = this.activeUploadTab === 'uploadFile' ? '' : 'translateX(96px)'
        this.clearUploadInput()
      })
    },
    triggerUpload(operate, row) {
      this.operate = operate
      this.fileTable = []
      this.selectFile = []
      this.clearUploadInput()
      if (row.fileType === '数维道路') {
        this.clickUploadInput()
      } else {
        this.$nextTick(() => {
          if (this.$refs.renewalUpload) {
            this.$refs.renewalUpload.clearFiles() // 清空已上传的文件列表
            this.$refs.renewalUpload.$refs['upload-inner'].handleClick()
          }
        })
      }
    },
    dialogOpen() {
      /** 由于这些参数涉及到业务接口传参, 所以不能在关闭的时候立即重置为默认值，故需要在打开dialog的时候再重置 **/
      this.fileTable = []
      this.selectFile = []
      this.activeUploadTab = this.softwareCode === 'AppGroad' ? 'uploadGroad' : 'uploadFile'
    },

    // tabs切换
    async beforeUploadTabChange(activeName, oldActiveName) {
      if (this.fileTable.length) {
        await this.$confirm('切换后已选择的文件将被清空', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          showClose: false,
          customClass: 'message-box-class',
          iconClass: 'el-icon-warning'
        }).then(() => {
          this.fileTable = []
          this.selectFile = []
          return true
        }).catch(() => {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject()
        })
      } else {
        return true
      }
    },

    // 点击了文件夹上传
    clickUploadInput() {
      if (this.fileTable.length) { return }
      this.$nextTick(() => {
        const input = document.getElementById('folderUploadInput')
        input && input.click()
      })
    },
    // 清空文件夹上传的所选文件
    clearUploadInput() {
      const input = document.getElementById('folderUploadInput')
      if (input) {
        input.value = ''
      }
      this.directoryFiles = null
      this.directoryName = ''
    },
    directoryChange(e) {
      this.directoryFiles = e.target.files // e.target.files是个对象
      if (this.directoryFiles.length) {
        const filePath = this.directoryFiles[0].webkitRelativePath
        this.directoryName = filePath.split('/')[0]
        // 校验是否是道路文件
        let isGroadFile = false
        const len = this.directoryFiles.length
        for (let i = 0; i < len; i++) {
          const file = this.directoryFiles[i]
          if (file.webkitRelativePath === `${this.directoryName}/data.db`) {
            isGroadFile = true
            break
          }
        }
        if (isGroadFile) {
          const file = {
            name: `${this.directoryName}.数维道路`,
            uid: Date.now() + Math.random().toString(36).slice(2),
            operate: this.operate,
            uploadProgress: 0,
            uploadStatus: 'prepare',
            spaceCategoryId: this.spaceCategoryId,
          }
          if (this.operate === 'renewal') {
            // 更新时，需要用软件版本及空间资源id
            file.id = this.renewalObj.id
            file.spaceId = this.renewalObj.spaceId
            file.renewalName = this.renewalObj.name
            this.handleSelectionChange([file])
            this.renewalList.push(file)
            this.isFold = false
            this.activeTab = this.operate
            this.zipDirectoryAndUpload(file)
          } else {
            this.fileTable.push(file)
            this.$nextTick(() => {
              this.$refs.multipleTable.toggleRowSelection(this.fileTable[length - 1])
            })
          }
        } else {
          this.fileTable = []
          this.selectFile = []
          this.clearUploadInput()
          this.$message.error('选择的不是数维道路文件')
        }
      }
    },

    getSpecialMethod() {
      return {
        valid: (file) => {
          return true
        },
        uploadStart: async() => {
          if (this.operate === 'renewal') {
            await this.$refs.renewalUpload.submit()
            this.$refs.renewalUpload && this.$refs.renewalUpload.clearFiles()
          } else {
            this.loading = true
            const selectFileLength = this.selectFile.length
            for (let i = 0; i < selectFileLength; i++) {
              const file = this.selectFile[i]
              const res = await this.$api.file.namesakeFile(this.$route.params.spaceId, this.spaceCategoryId, { name: file.name })
              if (res && res.length) {
                file.id = res[0].id
                file.renewalName = res[0].name
                file.operate = 'renewal'
              }
              const targetArr = file.operate === 'upload' ? this.uploadList : this.renewalList
              targetArr.push(file)
            }
            await this.$refs.upload.submit()
            // 提交上传后，清空上传列表，以免不触发preUpload方法。
            this.$refs.upload && this.$refs.upload.clearFiles()
          }
          this.loading = false
          this.modalVisible = false
          this.isFold = false
          this.activeTab = this.operate
        },
      }
    },

    fmtSize(file) {
      return (file.size || file.size === 0) ? Tools.fmtSize(file.size) : '--'
    },
    fmtFileName(file) {
      const fileName = file.name || file.renewalName
      return fileName.endsWith('.数维道路') ? fileName.split('.数维道路')[0] : fileName
    },
    showList(tab) {
      this.activeTab = tab
    },
    handleCancel() {
      this.modalVisible = false
    },
    handleOk() {
      if (this.activeUploadTab === 'uploadGroad') {
        this.uploadDirectory()
      } else {
        this.uploadStart()
      }
    },
    async uploadDirectory() {
      this.loading = true
      const file = this.selectFile[0]
      // 校验道路文件是否重名，若重名，则需要走更新逻辑。
      const res = await this.$api.file.namesakeFile(this.$route.params.spaceId, this.spaceCategoryId, { name: file.name })
      if (res && res.length) {
        file.id = res[0].id
        file.renewalName = res[0].name
        file.operate = 'renewal'
      }
      const targetArr = file.operate === 'upload' ? this.uploadList : this.renewalList
      targetArr.push(file)
      this.loading = false
      this.modalVisible = false
      this.isFold = false
      this.activeTab = this.operate
      this.zipDirectoryAndUpload(file)
    },
    // 压缩文件夹，并开始上传
    zipDirectoryAndUpload(file) {
      // 压缩道路文件夹
      this.$zip(this.directoryFiles).then((zipBlob) => {
        file.raw = zipBlob
        file.size = zipBlob.size
        file.uploadStatus = 'waiting'
        // 直接上传压缩后的文件。
        this.preUpload(file)
      })
    },

    // 更新文件状态、进度条等
    updateFile(file, newOpts) {
      const targetArr = file.operate === 'upload' ? this.uploadList : this.renewalList
      targetArr.forEach((item, index) => {
        if (item.uid === file.uid) {
          item = { ...item, ...newOpts }
          targetArr.splice(index, 1, item)
        }
      })
    },
    // 开始上传流程
    async uploadStart() {
      await this.getSpecialMethod().uploadStart()
    },
    // 检验文件
    validFileInfo(file) {
      return this.getSpecialMethod().valid(file)
    },
    // 上传文件列表变化后
    fileListChange(file, fileList) {
      if (this.fileTable.find((it) => { return it.name === file.name })) {
        this.$message.error('文件名称重复，已自动删除重名文件')
        // 为了使fileList.length与this.fileTable.length保持一致，从而关闭全局loading
        const index = fileList.findIndex((it) => { return it.uid === file.uid })
        fileList.splice(index, 1)
        return
      }
      this.fileChangeValid(file)
    },
    async fileChangeValid(file) {
      const name = Utils.getFileName(file.name)
      if (name.length > 30) {
        const suffix = file.name.split('.').slice(-1)
        file.name = name.substring(0, 30) + '.' + suffix
      }
      file.operate = this.operate
      file.uploadProgress = 0
      file.uploadStatus = 'waiting'
      const valid = this.validFileInfo(file)
      if (this.operate === 'renewal') {
        this.handleSelectionChange([file])
        this.renewalList.push(file)
        await this.uploadStart()
      } else {
        this.fileTable.push(file)
        const length = this.fileTable.length
        if (valid) {
          this.$nextTick(() => {
            this.$refs.multipleTable.toggleRowSelection(this.fileTable[length - 1])
          })
        }
      }
    },
    // 进度条颜色
    customColor(row) {
      switch (row.uploadStatus || row.status) {
        case 'success': return '#52C41A'
        case 'updateSuccess':return '#52C41A'
        case 'uploading': return '#1890FF'
        case 'waiting': return '#FF9E50'
        case 'fail': return '#BFBFBF'
        case 'md5Duplicate': return '#BFBFBF'
        case 'versionMismatch': return '#BFBFBF'
        case 'existed':return '#BFBFBF'
      }
    },
    // 上传成功
    uploadSuccess(file) {
      this.updateFile(file, { uploadProgress: 100 })
      if (file.storeId) {
        this.$emit('success', { file, id: file.storeId })
      } else {
        this.uploadError(file)
      }
    },
    // 上传失败
    uploadError(file) {
      this.updateFile(file, { uploadStatus: 'fail' })
      if (this.operate === 'renewal' && this.canEmitWebEventToDesktop) {
        this.$desktopClient.EmitWebEvent({ 
          eventName: 'file-renewal-finish',
          eventArgs: JSON.stringify({ 
            success: false, 
            message: 'upload error'
          }) 
        })
      }
    },
    // 勾选上传的文件后
    handleSelectionChange(val) {
      this.selectFile = val
    },
    // 判断文件是否可勾选
    canSelect(row) {
      return this.validFileInfo(row)
    },
    // 检查文件
    checkFile(file) {
      const size = file.size
      if (!size) {
        this.$message.error(`文件内容为空，已自动删除不符合的文件`)
        return false
      }
      const allowTypes = this.allowTypes.split(',')
      const arr = file.name.split('.')
      const type = '.' + arr[arr.length - 1].toLowerCase()
      const isType = allowTypes.indexOf(type) > -1
      if (!isType) {
        this.$message.error(`文件格式有误，已自动删除不符合的文件`)
        return false
      }
      const isNameInvalid = this.RegSymbol.test(file.name)
      if (isNameInvalid) {
        this.$message.error(`文件名中含禁用字符，已自动删除不合规文件`)
        return false
      }
      return true
    },
    onExceed() {
      this.$message.error('单次上传文件数不能大于100个，请分批上传.')
    },
    // 文件列表变化
    async fileChange(file, fileList) {
      if (this.operate === 'renewal') {
        const suffix = file.name.split('.').slice(-1)[0]
        const isSupport = suffix && suffix.toLowerCase() === this.renewalObj.suffix.toLowerCase()
        if (!isSupport) {
          this.fileTable = []
          this.selectFile = []
          this.$message.error('当前文件更新版本，仅支持' + this.renewalObj.suffix + '格式')
          return
        }
      }
      if (file.status === 'ready') {
        if (!this.checkFile(file)) {
          const index = fileList.findIndex((x) => { return x.uid === file.uid })
          fileList.splice(index, 1)
          if (this.operate === 'renewal' && this.canEmitWebEventToDesktop) {
            this.$desktopClient.EmitWebEvent({ 
              eventName: 'file-renewal-finish',
              eventArgs: JSON.stringify({ 
                success: false, 
                message: 'check file not pass'
              }) 
            })
          }
          return
        }
        if (this.operate === 'renewal' && this.renewalObj && this.renewalObj.id) {
          // 更新时，需要用软件版本及空间资源id
          file.id = this.renewalObj.id
          file.spaceId = this.renewalObj.spaceId
          file.renewalName = this.renewalObj.name
        }
        file.spaceCategoryId = this.spaceCategoryId
        this.fileListChange(file, fileList)
      }
    },

    /**
         * 准备上传文件：
         * 如果上传中的文件数量uploadingCount < 最大可上传的数量maxUploadingCount，则调用uploading（）直接上传
         * 否则，加入uploadQueue队列，等待上传*/
    async preUpload(payload) {
      const payloadFile = payload.file ? payload.file : payload
      const file = this.selectFile.find((f) => f.uid === payloadFile.uid && f.uploadStatus !== 'fail')
      if (file) {
        this.upQueue.preDo(file)
      }
    },
    /**
         * 等待上传的文件push到上传队列中*/
    uploadWait(file) {
      this.updateFile(file, { uploadStatus: 'waiting' })
    },
    /**
         * 进度条更新*/
    processCb(file, percentage) {
      this.updateFile(file, { uploadProgress: percentage })
    },
    /**
         * 文件开始上传 */
    async uploading(file) {
      try {
        const that = this
        that.updateFile(file, { uploadStatus: 'uploading' })
        const fileInfo = await Upload.uploadFile.call(that, file, false, that.processCb)
        if (fileInfo) {
          this.success(fileInfo)
        } else {
          this.error(file)
        }
      } catch (err) {
        this.error(file)
      }
    },
    // 上传成功
    success(file) {
      this.uploadSuccess(file)
      this.upQueue.nextDo()
    },
    // 上传失败
    error(file) {
      this.uploadError(file)
      this.upQueue.nextDo()
    },
  },
}
</script>

<style lang="less" scoped>
  /deep/ .uploader-dialog .el-dialog__body {
    padding:10px;
  }
  /deep/ .uploader-dialog .el-dialog__footer {
    padding:unset;
  }
  /deep/ .uploader-dialog .footer {
    padding: 10px 16px;
    border-top: 1px solid #e8e8e8;
    .left {
      float: left;
    }
  }
  .footer-tip {
    margin-top: 8px;
  }
  .uploader{
    text-align: left;
  }
  .upload-click-area{
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &.upload-disabled{
      cursor: not-allowed;
      color: #bfbfbf;
    }
    .el-icon-upload{
      font-size: 67px;
      color: #bfbfbf;
      margin: 40px 0 16px;
      line-height: 50px;
    }
  }
  .uploader-tip{
    font-size: 12px;
    color: rgba(73, 95, 112, 0.6);
    .strong{
      font-weight: bold;
      color: @text-tag-gery;
    }
  }
  .el-upload__tip, .upload-tip{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .upload-tip{
    font-size: 12px;
    color: #495F70;
    margin-bottom: 7px;
  }
  .red{
    color:@error-color;
  }
  .green{
    color:@success-color;
  }
  .yellow{
    color:@warning-color;
  }
  .dialog-title{
    font-size: 16px;
    margin-right: 14px;
  }
  .upload-list {
    position: relative;
    margin-left: 4px;
    width:480px;
    background: #ffffff;
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid @border-color;

    .tabs{
      display: flex;
      .tab-item{
        min-width: 54px;
        padding: 0 2px 10px;
        cursor: pointer;
        position: relative;
        text-align: center;
        margin-right: 12px;
        &::after{
          position: absolute;
          content: '';
          bottom: 1px;
          left: 0;
          background-color: transparent;
          width: 100%;
          height: 2px;
        }
        &.active{
          &::after{
            background-color:@theme-color;
          }
          .total{
            background-color: @theme-color-hover;
            color: @theme-color;
          }
        }
        .total{
          margin-left: 8px;
          display: inline-block;
          height: 20px;
          min-width: 24px;
          background: @bg-grey-dark;
          border-radius: 50%;
        }
      }
    }

    &.list-fold {
      height: 40px;
      .upload-list-header{
        border-bottom: none;
      }
    }

    .upload-list-header {
      height: 40px;
      border-bottom: 1px solid #d9d9d9;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .upload-list-content{
      position: relative;
      background: #F8F8F8;
      padding: 8px 14px 35px;
      .upload-content-tip{
        position: absolute;
        bottom: 8px;
        left: 10px;
      }
    }
    .file-list{
      height: 222px;
      overflow-y: auto;
      .file{
        display: flex;
        align-items: center;
        padding: 0 10px;
        height: 48px;
        border: 1px solid #E6E6E6;
        background: #FFFFFF;
        border-radius: 2px;
        margin-bottom: 4px;
        &:last-child{
          margin-bottom: 0;
        }
        .name{
          width: 180px;
        }
        .size{
          width: 84px;
          color: @text-sub-gery;
        }
        .progress{
          box-sizing: border-box;
          width: 80px;
          padding: 0 10px 0 12px;
        }
      }
    }
    .empty-content{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .rotate-control {
      cursor: default;
    }

    .rotate-icon {
      display: inline-block;
      transform: rotate(180deg);
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

      &.icon-fold {
        transform: rotate(0deg);
      }
    }
    .status-span{
      box-sizing: border-box;
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      i{
        margin-right:4px;
        font-size:12px;
      }
    }
    .success{
      color: @success-color;
    }
    .waiting{
      color: @warning-color;
    }
    .uploading, .prepare{
      color: @text-blue;
    }
    .error{
      color: @error-color;
    }
    .strong-color {
      color: @text-tag-gery;
    }
  }
</style>
